import React from 'react';
import { QuoteIcon } from 'lucide-react';
interface TestimonialCardProps {
  text: string;
  headline?: string;
  headlineNode?: React.ReactNode;
  highlight?: boolean;
  profileImage?: string;
  name?: string;
}
export function TestimonialCard({
  text,
  headline,
  headlineNode,
  highlight = false,
  profileImage,
  name = 'Peptide Science Institute Transformation Client'
}: TestimonialCardProps) {
  const paragraphs = text.split('\n\n');
  return <div className="space-y-4" data-id="element-379">
      {headlineNode ? <p className="text-xl md:text-2xl font-semibold text-ink leading-snug text-center" data-id="element-380">
          {headlineNode}
        </p> : headline ? <p className="text-xl md:text-2xl font-semibold text-ink leading-snug text-center" data-id="element-381">
          {headline.includes('"borderline miracle."') ? <>
              {headline.split('"borderline miracle."')[0]}
              <span className="block text-2xl md:text-3xl font-black text-teal-600 italic mt-1" data-id="element-382">
                "borderline miracle."
              </span>
            </> : headline.includes('"borderline miracle"') ? <>
              {headline.split('"borderline miracle"')[0]}
              <span className="block text-2xl md:text-3xl font-black text-teal-600 italic mt-1" data-id="element-383">
                "borderline miracle"
              </span>
              {headline.split('"borderline miracle"')[1]}
            </> : headline}
        </p> : null}
      <div className="relative bg-teal-50/40 border border-black/5 border-l-4 border-l-teal-400 rounded-2xl p-8 md:p-10 shadow-sm" data-id="element-384">
        <div className={`flex ${profileImage ? 'flex-col md:flex-row gap-6 md:gap-8' : ''}`} data-id="element-385">
          {profileImage && <div className="flex-shrink-0" data-id="element-386">
              <img src={profileImage} alt="Client" className="w-16 h-16 md:w-20 md:h-20 rounded-full object-cover bg-gray-100" data-id="element-387" />
            </div>}
          <div className="flex-1" data-id="element-388">
            <QuoteIcon className="w-5 h-5 text-teal-500 mb-4 opacity-80" data-id="element-389" />
            <div className="space-y-3" data-id="element-390">
              {paragraphs.map((para, i) => {
              const isResults = para.trim() === 'RESULTS:';
              const highlight = "they are likely in the top 5 most important people I've ever met";
              const hasHighlight = para.includes(highlight);
              return <p key={i} className={`text-lg md:text-xl font-light leading-relaxed ${isResults ? 'font-bold text-teal-700 tracking-wide not-italic' : 'text-ink'}`} data-id="element-391">
                    {i === 0 && '"'}
                    {hasHighlight ? (() => {
                  const parts = para.split(highlight);
                  return <>
                              {parts[0]}
                              <span className="block text-2xl md:text-3xl font-black text-teal-600 italic my-2 leading-tight" data-id="element-392">
                                "they are likely in the top 5 most important
                                people I've ever met"
                              </span>
                              {parts[1]}
                            </>;
                })() : para}
                    {i === paragraphs.length - 1 && '"'}
                  </p>;
            })}
            </div>
            <div className="flex items-center gap-3 mt-6" data-id="element-393">
              <div className="h-px w-6 bg-teal-200" data-id="element-394"></div>
              <p className="text-xs text-teal-600 font-bold tracking-wider uppercase" data-id="element-395">
                {name}
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>;
}